import { Roles, type Role } from "../../auth/roles";
import type { AreaRoute } from "./areaRoute";
import { lazyPage } from "../../lib/lazyPage";

const ShipmentWorkspacePage = lazyPage(
  () => import("../logistics/shipment/ShipmentWorkspacePage"),
  "ShipmentWorkspacePage"
);

// Release 1.9.0 (Logistics): routes for the Logistics hub, inbox, shipment workspace, and Coming & Going dashboard.
// Worker B registers /logistics/shipments/:id; Workers A and D add their routes here as well.

export const LogisticsReaders: readonly Role[] = [
  "Logistics" as Role,
  Roles.ShippingManager,
  Roles.Purchasing,
  Roles.PurchasingManager,
  Roles.OperationsManager,
  Roles.Planner,
  Roles.PlantManager,
  Roles.Executive,
  Roles.Admin
];

export const LogisticsShippers: readonly Role[] = [
  "Logistics" as Role,
  Roles.ShippingManager,
  Roles.Admin
];

export { ShipmentWorkspacePage };

export const logisticsRoutes: AreaRoute[] = [
  {
    path: "/logistics/shipments/:id",
    allow: LogisticsReaders,
    element: <ShipmentWorkspacePage />
  }
];
